import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Alert, Spinner } from 'react-bootstrap';
import { FiLock, FiUser, FiShield, FiFileText, FiCheckCircle } from 'react-icons/fi';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/admin/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      {/* Left panel */}
      <div className="login-left">
        <div className="login-left-content">
          <img
            src="/Ajar enterprise logo white.png"
            alt="Ajar | Enterprise"
            style={{ maxWidth: 280, width: '100%', objectFit: 'contain' }}
          />
        </div>
      </div>

      {/* Right panel */}
      <div className="login-right">
        <div className="login-form-wrap">
          <h2>Welcome back</h2>
          <p className="login-subtitle">Sign in to your account to continue</p>

          {error && (
            <Alert variant="danger" className="py-2 px-3 mb-3">
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Username</label>
              <div style={{ position: 'relative' }}>
                <span style={{
                  position: 'absolute', left: '0.75rem', top: '50%',
                  transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '0.95rem',
                }}>
                  <FiUser />
                </span>
                <input
                  type="text"
                  className="form-control"
                  style={{ paddingLeft: '2.25rem' }}
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoFocus
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <span style={{
                  position: 'absolute', left: '0.75rem', top: '50%',
                  transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '0.95rem',
                }}>
                  <FiLock />
                </span>
                <input
                  type="password"
                  className="form-control"
                  style={{ paddingLeft: '2.25rem' }}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 py-2"
              disabled={loading}
              style={{ fontSize: '0.95rem', fontWeight: 600 }}
            >
              {loading ? (
                <><Spinner size="sm" animation="border" className="me-2" />Signing in…</>
              ) : 'Sign In'}
            </button>
          </form>

          <p style={{ marginTop: '2rem', fontSize: '0.78rem', color: '#9ca3af', textAlign: 'center' }}>
            NFC Vehicle Document Management System
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
